import * as React from "react";
import * as ReactDOM from "react-dom/client";

const components: Record<string, React.ComponentType<any>> = {};

export function registerComponent(
  newComponents: Record<string, React.ComponentType<any>>,
) {
  Object.assign(components, newComponents);
}

export function renderComponents() {
  document
    .querySelectorAll<HTMLElement>("[data-react-component-name]")
    .forEach((element) => {
      const name = element.dataset.reactComponentName;
      const propsJson = element.dataset.reactComponentProps || "{}";
      const props = JSON.parse(propsJson);

      const Component = components[name!];
      if (Component) {
        const root = ReactDOM.createRoot(element);
        root.render(React.createElement(Component, props));
      } else {
        console.error(`Component not found: ${name}`);
      }
    });
}
